import axios from 'axios';
import { SEND_PW_RESET_MAIL } from '../mutations/auth.mutations';

const authResolvers = {
  Query: {
    getTerms: async (_, __, { client }) => {
      const { config } = client.defaultOptions;

      try {
        const { data } = await axios.get(config.getTermsUrl());

        return { terms: data };
      } catch (error) {
        throw new Error(error.message);
      }
    },
  },
  Mutation: {
    sendPasswordResetMail: async (_, { email }, { client }) => {
      try {
        await client.mutate({
          mutation: SEND_PW_RESET_MAIL,
          variables: {
            email,
          },
        });
      } catch (error) {
        throw new Error(error.message);
      }
    },
    login: async (_, { password, email }, { client }) => {
      const firebase = client.defaultOptions.firebase.getFirebase();
      try {
        await firebase.auth().signInWithEmailAndPassword(email, password);
      } catch (error) {
        throw new Error(error.code || error.message);
      }
    },
    tokenizedLogin: async (_, { token }, { client }) => {
      try {
        const auth = client.defaultOptions.firebase.getFirebase().auth();
        await auth.signInWithCustomToken(token);
        const idToken = await auth.currentUser.getIdToken();
        await axios.post(
          process.env.REACT_APP_GQL_SECURE_ENDPOINT,
          {
            query: `
              mutation VerifyUser {
                verifyUser {
                  id
                }
              }
            `,
          },
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
              'Content-Type': 'application/json',
            },
          }
        );
      } catch (error) {
        throw new Error('Your invitation is invalid. Please contact your account administrator!');
      }
    },
    registerInvitedUserWithToken: async (_, { token, input }, { client }) => {
      const auth = client.defaultOptions.firebase.getFirebase().auth();
      try {
        await auth.signInWithCustomToken(token);
      } catch {
        throw new Error('Your invitation is invalid. Please contact your account administrator!', {
          cause: 'INVALID_INVITATION_LINK',
        });
      }

      try {
        const idToken = await auth.currentUser.getIdToken();
        await axios.post(
          process.env.REACT_APP_GQL_SECURE_ENDPOINT,
          {
            query: `
              mutation RegisterInvitedUser($input: InvitedUserRegistrationInput!) {
                registerInvitedUser(input: $input) {
                  id
                }
              }
            `,
            variables: { input },
          },
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
              'Content-Type': 'application/json',
            },
          }
        );
      } catch (error) {
        if (error instanceof Error) {
          throw new Error(error.message);
        } else {
          throw new Error('An unknown error occurred');
        }
      }
    },
  },
};

export default authResolvers;
